import { Icon3DTour16, IconDateTime16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PhotoFeatureIcons.css';
import { EPhotoFeatureIcon, IPhotoFeatureIcon } from '../../types';
import { PhotoFeatureIcon } from '../PhotoFeatureIcon';

export interface IPhotoFeatureIcons {
  photoFeatureIcons: IPhotoFeatureIcon[] | null | undefined;
  isExternalTourHide: boolean;
}

const icons: { [type: string]: React.ReactNode } = {
  has3dTour: <Icon3DTour16 color="white_100" data-name="3D-tour-icon" />,
  hasFlatTourBooking: <IconDateTime16 color="white_100" />,
};

const PhotoFeatureIconsComponent: React.FC<IPhotoFeatureIcons> = ({ isExternalTourHide, photoFeatureIcons }) => {
  if (!photoFeatureIcons || photoFeatureIcons.length === 0) {
    return null;
  }

  let filteredIcons = [...photoFeatureIcons];

  if (isExternalTourHide) {
    filteredIcons = [...photoFeatureIcons.filter(icon => icon.type !== EPhotoFeatureIcon.Has3dTour)];
  }

  return (
    <div className={styles['container']}>
      {filteredIcons.map(photoFeatureIcon => {
        const type = photoFeatureIcon.type;
        const icon = icons[type];

        return <PhotoFeatureIcon key={type} icon={icon} className={styles['icon']} />;
      })}
    </div>
  );
};

export const PhotoFeatureIcons = React.memo(PhotoFeatureIconsComponent);
